/**
 * Vocabulário do domínio do YDChat, compartilhado entre servidor e interface.
 * Os valores são os mesmos gravados no banco (colunas text com CHECK), então
 * mudar um valor aqui exige migration.
 */

export const PAPEIS = ["admin", "gerencia", "vendedora"] as const;
export type Papel = (typeof PAPEIS)[number];

export const ROTULO_PAPEL: Record<Papel, string> = {
  admin: "Administrador",
  gerencia: "Gerência",
  vendedora: "Vendedora",
};

/** Gerência e administrador enxergam a operação inteira. */
export function veOperacaoInteira(papel: Papel): boolean {
  return papel === "admin" || papel === "gerencia";
}

export const STATUS_PRESENCA = ["disponivel", "ocupada", "pausa", "offline"] as const;
export type StatusPresenca = (typeof STATUS_PRESENCA)[number];

export const ROTULO_PRESENCA: Record<StatusPresenca, string> = {
  disponivel: "Disponível",
  ocupada: "Ocupada",
  pausa: "Pausa",
  offline: "Offline",
};

/** Canais de atendimento. Só WhatsApp por enquanto; o resto do sistema já
 * trata o canal como dado, não como suposição. */
export const TIPOS_CANAL = ["whatsapp"] as const;
export type TipoCanal = (typeof TIPOS_CANAL)[number];

/** Ciclo de vida técnico da conversa (se está aberta ou não). */
export const STATUS_CONVERSA = ["aberta", "aguardando_cliente", "encerrada"] as const;
export type StatusConversa = (typeof STATUS_CONVERSA)[number];

/** Etapa comercial (funil). Separada das etiquetas, que classificam o cliente. */
export const ETAPAS_CONVERSA = [
  "novo_atendimento",
  "em_atendimento",
  "aguardando_cliente",
  "escolhendo_produto",
  "negociacao",
  "aguardando_pagamento",
  "pagamento_confirmado",
  "pedido_criado",
  "pos_venda",
  "finalizado",
] as const;
export type EtapaConversa = (typeof ETAPAS_CONVERSA)[number];

export const ROTULO_ETAPA: Record<EtapaConversa, string> = {
  novo_atendimento: "Novo atendimento",
  em_atendimento: "Em atendimento",
  aguardando_cliente: "Aguardando cliente",
  escolhendo_produto: "Escolhendo produto",
  negociacao: "Venda em negociação",
  aguardando_pagamento: "Aguardando pagamento",
  pagamento_confirmado: "Pagamento confirmado",
  pedido_criado: "Pedido criado",
  pos_venda: "Pós-venda",
  finalizado: "Finalizado",
};

/** Quem conduz a conversa no momento: vendedora, IA em modo ponte (cliente
 * esperando) ou atendimento assistido com a loja fechada. */
export const MODOS_CONVERSA = ["humano", "ponte", "fora_horario"] as const;
export type ModoConversa = (typeof MODOS_CONVERSA)[number];

export const DIRECOES_MENSAGEM = ["entrada", "saida", "interna"] as const;
export type DirecaoMensagem = (typeof DIRECOES_MENSAGEM)[number];

export const AUTORES_MENSAGEM = ["contato", "usuario", "ia", "sistema"] as const;
export type AutorMensagem = (typeof AUTORES_MENSAGEM)[number];

export const TIPOS_MENSAGEM = [
  "texto",
  "imagem",
  "audio",
  "video",
  "documento",
  "localizacao",
  "contato",
  "figurinha",
  "reacao",
  "interativo",
  "template",
  "nota_interna",
  "sistema",
  "desconhecido",
] as const;
export type TipoMensagem = (typeof TIPOS_MENSAGEM)[number];

export const STATUS_MENSAGEM = [
  "pendente",
  "enviada",
  "entregue",
  "lida",
  "falhou",
  "recebida",
] as const;
export type StatusMensagem = (typeof STATUS_MENSAGEM)[number];

export const TIPOS_ATRIBUICAO = [
  "automatica",
  "manual",
  "transferencia",
  "retirada",
  "escalonamento",
] as const;
export type TipoAtribuicao = (typeof TIPOS_ATRIBUICAO)[number];

/** Janela de atendimento da Meta: fora dela, só template aprovado. */
export const JANELA_ATENDIMENTO_MS = 24 * 60 * 60 * 1000;
